module.exports = __webpack_public_path__ + "static/media/App.58e5bb95.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 71
// module chunks = 0